import { HeatingTypeContainer } from '../../containers/advancedFilters/HeatingTypeContainer';
import { IFilter } from '../../types/advancedFilters';

export const heatingType: IFilter = {
  component: HeatingTypeContainer,
};
